import { useState, useMemo } from "react";

export default function useSearchableTable(data = []) {
  const [searchText, setSearchText] = useState("");

  const filteredData = useMemo(() => {
    if (!data?.length) return [];
    if (!searchText) return data;
    
    return data.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [data, searchText]);

  return {
    searchText,
    setSearchText,
    filteredData,
  };
}
